const MuiAccordion = {
  styleOverrides: {
    root: {
      borderRadius: '2px',
      '&:before': {
        content: 'none'
      },
      '&.Mui-expanded': {
        margin: '10px 0'
      }
    }
  }
};
export default MuiAccordion;